<template>
  <div class="container-EXPONDO lg:py-10">
    <div class="content-block-wrapper lg:grid grid-cols-[360px_1fr] gap-6">
      <SkeletonLoader
        height="933px"
        class="lg:block hidden"
      />
      <SkeletonLoader
        height="1200px"
      />
    </div>
  </div>
</template>
<script lang="ts">

export default defineComponent({
  name: 'CmsPageSkeleton',
});

</script>
